import MarkerVisibilityFilter from './MarkerVisibilityFilter'



const MapFilter = props => {
  return (
    <MarkerVisibilityFilter />
  )
}



export default MapFilter